import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BankAccountsFeatureName, BankAccountsFeatureAdapter } from './bank-accounts.reducer';
import { BankAccountsEntityState } from '../../interfaces';

//const EntitySelectors = BankAccountsFeatureAdapter.getSelectors();

export const BankAccountsFeatureSelector =
    createFeatureSelector<BankAccountsEntityState>('BankAccounts');

export const getBankAccountsListData = (data: BankAccountsEntityState): BankAccountsEntityState => data;

export const getBankAccountsListDataSelector = createSelector(
    BankAccountsFeatureSelector,
    getBankAccountsListData
);
